export default "__VITE_ASSET__4b0ba637__"